'use strict';
import axios from 'axios';
import Config from '../Config';
import ErrorResponse from './providerErrorRespons';
import Error from '../constans/providerErrorCode';
import {getDeviceId, getSessionId} from '../utilities/userStorageAPI/localStorageAPI';
import AuthenticationProvider from '../utilities/authentication/authenticationProvider';

class ProviderFetch {
  static async get(ObjData, funcStringParams, token) {
    let fetchObj = this.getFetchObj(ObjData, funcStringParams, token);
    try {
      return axios(fetchObj)
        .then((res) => {
          if (res.status === 200) {
            return Promise.resolve(res.data);
          } else {
            return Promise.reject(
              new ErrorResponse(Error.UNAUTHORIZED.errorCode, Error.UNAUTHORIZED.errorDesc, Error.UNAUTHORIZED.friendlyDesc, res.status)
            );
          }
        })
        .catch((e) => {
          if (e.toString().includes('401')) {
            AuthenticationProvider.clearAuthenticationData();
            window.location.reload();
          }
          return Promise.reject(e);
        });
    } catch (e) {
      if (e === 'TypeError: Failed to fetch' || e === 'TypeError: Network request failed')
        return Promise.reject(
          new ErrorResponse(Error.CONNECTION_ERROR.errorCode, Error.CONNECTION_ERROR.errorDesc, Error.CONNECTION_ERROR.friendlyDesc, '')
        );
      else return Promise.reject(e);
    }
  }

  static getFetchObj(ObjData, funcStringParams, token) {
    let fetchObj = {};
    let headers = {};

    if (token && (ObjData.requiredLogin || ObjData.isDualAuthentication)) {
      headers['Authorization'] = 'Bearer ' + token;
    }

    headers['DeviceId'] = getDeviceId();
    headers['ClientID'] = Config.client_id;
    headers['SessionID'] = getSessionId();

    for (let key in ObjData.headers) {
      if (Object.prototype.hasOwnProperty.call(ObjData.headers, key)) {
        headers[key] = ObjData.headers[key];
      }
    }

    const methodType = ObjData.httpMethod.toLowerCase();

    if (methodType === 'get') {
      const url = funcStringParams && funcStringParams != '{}' ? ObjData.apiSuffixName + '/' + funcStringParams : ObjData.apiSuffixName;

      fetchObj = {
        baseURL: Config.apiGwUrl,
        url: url,
        method: 'get',
        timeout: ObjData.timeout ?? Config.defaultTimeout,
        headers: headers,
      };
    } else {
      fetchObj = {
        method: methodType,
        baseURL: Config.apiGwUrl,
        url: ObjData.apiSuffixName,
        data: funcStringParams,
        headers: headers,
      };
    }
    
    if (ObjData.withCredentials && process.env.NODE_ENV !== 'development') {
      fetchObj.withXSRFToken = true;
      fetchObj.withCredentials = true;
      fetchObj.xsrfCookieName = 'EEDS';
      fetchObj.xsrfHeaderName = 'X-XSRF-TOKEN';
    }
    
    return fetchObj;
  }
}

export default ProviderFetch;
